export default {"src":"/_next/static/media/laptop-moderate.6d540115.svg","height":71,"width":113};